import { CloseModalButton } from '@library/components/buttons';
import type { Deposit } from '@library/types/payments';

interface DepositsDetailHeaderProps {
  deposit: Deposit;
  onCancelModal: () => void;
}

export const DepositsDetailHeader = ({
  deposit,
  onCancelModal
}: DepositsDetailHeaderProps) => (
  <>
    <div className="flex h-full items-center justify-center px-5">
      <h3 className="text-2xl">Deposit Detail</h3>
    </div>
    <div className="ml-auto flex h-full items-center justify-center">
      <div className="pr-5">{deposit.merchantReferenceId}</div>
      <CloseModalButton
        handleOnClick={onCancelModal}
        useDefaultStyling={false}
      />
    </div>
  </>
);
